<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/ads-campaigns/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/ads-campaigns/${this.$route.params.id}/edit`,
                    },
                ],
            };
        },
    };
</script>
